import { Diagnostic } from "@siteimprove/alfa-act";
import { Either } from "@siteimprove/alfa-either";
import { Sequence } from "@siteimprove/alfa-sequence";
import { WithName } from "./with-name.js";
export class WithBoundingBox extends WithName {
    static of(message, name, box, condition, tooCloseNeighbors) {
        if (name === undefined) {
            return new Diagnostic(message);
        }
        if (box === undefined ||
            condition === undefined ||
            tooCloseNeighbors === undefined) {
            return new WithName(message, name);
        }
        return new WithBoundingBox(message, name, box, condition, tooCloseNeighbors);
    }
    _box;
    _condition;
    _tooCloseNeighbors;
    constructor(message, name, box, condition, tooCloseNeighbors) {
        super(message, name);
        this._box = box;
        // Copy the objects to ensure they are immutable from the outside.
        this._condition = condition.either((uaCond) => Either.left({ ua: uaCond.ua }), (sizeAndSpacingCond) => Either.right({
            size: sizeAndSpacingCond.size,
            spacing: sizeAndSpacingCond.spacing,
        }));
        this._tooCloseNeighbors = Sequence.from(tooCloseNeighbors);
    }
    get box() {
        return this._box;
    }
    get condition() {
        return this._condition;
    }
    get tooCloseNeighbors() {
        return this._tooCloseNeighbors;
    }
    equals(value) {
        return (value instanceof WithBoundingBox &&
            value._message === this._message &&
            value._name === this._name &&
            value._box.equals(this._box) &&
            value._condition.equals(this._condition) &&
            value._tooCloseNeighbors.equals(this._tooCloseNeighbors));
    }
    hash(hash) {
        super.hash(hash);
        this._box.hash(hash);
        this._condition.hash(hash);
        this._tooCloseNeighbors.hash(hash);
    }
    toJSON(options) {
        return {
            ...super.toJSON(options),
            box: this._box.toJSON(),
            condition: this._condition.toJSON(),
            tooCloseNeighbors: this._tooCloseNeighbors.toJSON(options),
        };
    }
}
(function (WithBoundingBox) {
    function isWithBoundingBox(value) {
        return value instanceof WithBoundingBox;
    }
    WithBoundingBox.isWithBoundingBox = isWithBoundingBox;
})(WithBoundingBox || (WithBoundingBox = {}));
//# sourceMappingURL=with-bounding-box.js.map